'use client'

import { useTranslation } from 'react-i18next'
import { HStack, Progress, Text } from '@chakra-ui/react'
import { HeartPulse } from 'lucide-react'
import type { IDonorCardDetail } from '@/entities/donor/model'
import { AppCard } from '@/shared'

interface Props {
  donor: IDonorCardDetail
}

export function DonorStatusCard({ donor }: Props) {
  const { t } = useTranslation()
  return (
    <AppCard.Root
      bg="card.red.100"
      color="white"
      h="full"
      boxShadow={{
        base: '0 4px 14px rgba(100, 26, 32, 0.28)',
        _dark: '0 8px 28px rgba(0, 0, 0, 0.5)',
      }}
    >
      <AppCard.Body p={5}>
        <HStack gap={2} mb={1}>
          <HeartPulse size={16} />
          <Text fontSize="xs" opacity={0.8} fontWeight="medium">
            {t('donor_detail.donor_status.title')}
          </Text>
        </HStack>
        <Text fontWeight="bold" fontSize="md" mb={4}>
          {donor.gamification.title}
        </Text>
        <Text fontSize="xs" opacity={0.75} mb={2}>
          {t('donor_detail.donor_status.to_next', {
            count: donor.gamification.donations_until_next,
          })}
        </Text>
        <Progress.Root
          value={donor.gamification.progress_percent}
          max={100}
          size="sm"
          colorPalette="red"
        >
          <Progress.Track bg="whiteAlpha.300" borderRadius="full">
            <Progress.Range bg="white" borderRadius="full" />
          </Progress.Track>
        </Progress.Root>
        <Text fontSize="xs" opacity={0.6} mt={1} textAlign="right">
          {donor.gamification.progress_percent}%
        </Text>
      </AppCard.Body>
    </AppCard.Root>
  )
}
